import * as QuizTypes from './quizTypes';

const initialState = { answeredQuizzes: [] };

export const QuizReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case QuizTypes.ADD_QUIZ_WITH_REPLIES:
            return {
                ...state,
                answeredQuizzes: [...state.answeredQuizzes, action.payload.quiz],
            };
        case QuizTypes.REMOVE_FORMATION_QUIZZES:
            return {
                ...state,
                answeredQuizzes: [
                    ...state.answeredQuizzes.filter((quiz) => quiz.formation_id !== action.payload.formation_id),
                ],
            };

        case QuizTypes.CLEAR_STATE:
            return {
                ...initialState,
            };

        default:
            return state;
    }
};
